<nz-layout class="app-layout">
  <nz-sider
    class="menu-sidebar"
    nzCollapsible
    nzWidth="256px"
    nzBreakpoint="md"
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
  >
    <div class="sidebar-logo">
      <a href="/">
        <img src="https://ng.ant.design/assets/img/logo.svg" alt="logo" />
        <h1>Game of Life</h1>
      </a>
    </div>
    <ul
      nz-menu
      nzTheme="dark"
      nzMode="inline"
      [nzInlineCollapsed]="isCollapsed"
    >
      <li nz-submenu nzOpen nzTitle="App" nzIcon="dashboard">
        <ul>
          <li nz-menu-item nzMatchRouter>
            <a routerLink="/game"><i nz-icon nzType="build"></i>Game</a>
          </li>
          <li nz-menu-item><i nz-icon nzType="setting"></i>Setting</li>
        </ul>
      </li>
      <li nz-menu-item nzMatchRouter>
        <a routerLink="/info"
          ><i nz-icon nzType="info-circle"></i
          >{{ isCollapsed ? "" : "Info" }}</a
        >
      </li>
    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <i
            class="trigger"
            nz-icon
            [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
          ></i>
        </span>
        <span>Conway's Game of Life</span>
      </div>
    </nz-header>
    <div class="inner-content">
      <router-outlet></router-outlet>
    </div>
  </nz-layout>
</nz-layout>
